// @ts-nocheck
/* eslint-disable */
export const asHelpIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 7.80501C8.32899 6.86977 8.97837 6.08114 9.83318 5.57879C10.6879 5.07646 11.6928 4.89283 12.67 5.06043C13.6472 5.22805 14.5334 5.73606 15.1719 6.49454C15.8103 7.253 16.1599 8.21296 16.1583 9.20438C16.1583 12.0031 11.9602 13.4025 11.9602 13.4025M12.0722 19H12.0862" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'help' as const
};